import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import { Link } from 'gatsby';
import React from 'react';

import DownloadFileIcon from './assets/svg/download-file.svg';
import CopyCode from './components/CopyCode';

const EMPTY_REFERENCE = {
  file: {},
};

export const withArticles = (category) =>
  Array.isArray(category.articles) && category.articles.length > 0;

export const withPosts = (tag) =>
  Array.isArray(tag.posts) && tag.posts.length > 0;

// eslint-disable-next-line no-unused-vars
export const rendererOptions = ({ locale = 'en-US' }, references) => ({
  renderNode: {
    [INLINES.ASSET_HYPERLINK]: (node) => {
      const linkID = node.data.target.sys.id;
      const {
        file: { url },
        title,
      } =
        references.find(({ contentful_id: id }) => id === linkID) ??
        EMPTY_REFERENCE;

      let Icon;
      const ext = url.split('.').pop();
      // eslint-disable-next-line default-case
      switch (ext) {
        case 'csv':
        case 'doc':
          Icon = DownloadFileIcon;
          break;
      }

      return (
        <>
          {Icon && (
            <>
              <Icon className="inline-block -mt-0.5 w-4 h-4" />{' '}
            </>
          )}
          <a href={url} title={title}>
            {node.content[0].value}
          </a>
        </>
      );
    },
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      const imageID = node.data.target.sys.id;
      const {
        file: { url },
        title,
      } =
        references.find(({ contentful_id: id }) => id === imageID) ??
        EMPTY_REFERENCE;

      return <img src={url} alt={title} />;
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      const entryID = node.data.target.sys.id;
      const entry =
        references.find(({ contentful_id: id }) => id === entryID) ??
        EMPTY_REFERENCE;

      return (
        <div className="py-4 border-t">
          {entry.__typename === 'ContentfulKbAppArticle' ? (
            <Link to={`/help/${entry.category.slug}/${entry.slug}/`}>
              {entry.title}
            </Link>
          ) : (
            <Link to={`/blog/${entry.slug}/`}>{entry.title}</Link>
          )}
        </div>
      );
    },
    // https://stackoverflow.com/a/57772877
    [BLOCKS.PARAGRAPH]: (node, children) => {
      if (
        node.content.length === 1 &&
        node.content[0].marks.find((m) => m.type === 'code')
      ) {
        return <CopyCode code={node.content[0].value} />;
      }

      return <p>{children}</p>;
    },
  },
});
